// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"77":"car","204":"my-cars","856":"car-sold","871":"legal"}[chunkId] + "." + {"77":"baea0043","204":"51d0d52d","856":"fa924ffd","871":"f4881eed"}[chunkId] + ".css";
};